<ng-template #contentTemplate><ng-content></ng-content></ng-template>
<ng-template #hintContentTemplate><ng-content select="[hint]"></ng-content></ng-template>

<div class="wrapper">
    <div
        *ngIf="isCustomContent$ | ngrxPush; else defaultContentTemplate"
        class="custom-content"
        [class.custom-content-selected]="selected"
        [class.custom-content-disabled]="disabled"
    >
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <ng-template #defaultContentTemplate>
        <dtm-ui-radio-field *ngIf="!multiple" [checked]="selected" [disabled]="disabled" [name]="parentId">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
            <div radioFieldHint *ngTemplateOutlet="hintContentTemplate"></div>
        </dtm-ui-radio-field>
        <dtm-ui-checkbox-field *ngIf="multiple" [checked]="selected" [disabled]="disabled">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
            <div checkboxFieldHint *ngTemplateOutlet="hintContentTemplate"></div>
        </dtm-ui-checkbox-field>
    </ng-template>
</div>
